<template>
  <div class="p-5 grid grid-cols-2 gap-4 text-center">
    <div @click.prevent="page = 'users'">
      <button type="button" class="px-6 py-2.5 bg-blue-600 text-white font-roboto font-medium leading-tight uppercase rounded shadow-md ml-1 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="cancel"><font-awesome-icon icon="fa-users" class="text-white text-lg" /></button>
    </div>
    <div @click.prevent="page = 'listRooms'">
      <button type="button" class="px-6 py-2.5 bg-blue-600 text-white font-roboto font-medium leading-tight uppercase rounded shadow-md ml-1 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="cancel"><font-awesome-icon icon="fa-comment-dots" class="text-white text-lg" /></button>
    </div>
  </div>
  <div class="min-w-[250px] max-w-[300px] h-[calc(100vh-150px)]" :class="{'overflow-y-auto': page != 'room', 'scrollbar-thin': page != 'room', 'scrollbar-thumb-gray-700': page != 'room', 'scrollbar-track-gray-200': page != 'room'}">
    <div v-if="page != 'room'" class="">
      <div class="p-5 overflow-x-hidden">
        <chat-users :users="users" v-if="page == 'users'" />
        <chat-list-rooms :rooms="roomsList" :users="users" v-if="page == 'listRooms'" />
      </div>
    </div>
    <chat-room :room="room" v-if="page == 'room'" />
  </div>
</template>
<script>
import fire from "./fire";
import { uuid } from 'vue-uuid';
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import ChatUsers from './ChatUsers'
import ChatListRooms from './ChatListRooms'
import ChatRoom from './ChatRoom'

export default {
  inject: ['chat_users'],
  components: {
    ChatUsers,
    ChatListRooms,
    ChatRoom,
  },
  props: {
    roomsUnreadMessages: {}
  },
  provide() {
    return {

    }
  },
  data() {
    return {
      rooms: [],
      page: 'listRooms',
      room: Object,
    };
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  methods: {
    createRoom(item) {
        let roomId = uuid.v1();

        let users = {
          [`${this.user.id}`]: false,
          [`${item.id}`]: false,
        };

        let room = {
            users: users,
            lastMessage: null,
            updatedAt: this.timestamp(),
            createdAt: this.timestamp(),
        }

        let updates = {
          [`rooms/${roomId}`]: room,
          [`user_rooms/${this.user.id}/${roomId}`]: true,
          [`user_rooms/${item.id}/${roomId}`]: true,
        }
        fire.database().ref().update(updates);

        return this.rooms.filter((val) => roomId == val.id).shift();
    },
    startRoom(item) {
      let _room = this.rooms.filter((val) => val.others.indexOf(item.id) >= 0).shift();
      if(typeof(_room) == "undefined") {
        _room = this.createRoom(item);
      }

      if(typeof(_room) != "undefined") {
        this.room = _room;
        this.page = 'room';
      }
    },
    openRoom(_room) {
      this.room = _room;
      this.page = 'room';
    },
    findUser(id) {
      let users = this.users.filter((val) => id == val.id);
      if(users.length) {
        return users[0];
      }
      return {};
    },
    loadUserRooms(userRooms) {
      this.rooms = [];
      userRooms.forEach((_userRoom) => {
        let userRoomKey = _userRoom.key;
        fire.database().ref('rooms/' + userRoomKey).on('value', this.loadRoom);
      });
    },
    loadRoom(_room) {
      let room = _room.val();

      this.rooms = this.rooms.filter((val) => val.id != _room.key);

      let others = Object.keys(Object.fromEntries(Object.entries(room.users).filter(([key]) => key != usePage().props.value.auth.user.id)));
      let othersNames = this.users.filter((val) => others.indexOf(val.id) >= 0).map((val) => val.name);

      if(!othersNames.length) {
        return;
      }

      let visible = true;
      if(Object.entries(room.users).filter(([key, value]) => key == usePage().props.value.auth.user.id && value === false).length) {
        visible = false;
      }

      this.rooms.push({
        id: _room.key,
        visible: visible,
        name: othersNames.join(', '),
        others: others,
        othersNames: othersNames,
        //unreadMessages: () => computed(() => this.roomsUnreadMessages[_room.key]).value,
        unreadMessages: () => this.roomsUnreadMessages[_room.key],
        //unreadMessages: this.roomsUnreadMessages[_room.key], // sem () nas chamadas
        lastMessage: room.lastMessage,
        users: room.users,
        updatedAt: room.updatedAt,
        createdAt: room.createdAt,
      });

      this.rooms.sort(function(a, b) {
        if(a.updatedAt > b.updatedAt) {
          return -1;
        }
        if(a.updatedAt < b.updatedAt) {
          return 1;
        }
        return 0;
      });
    },
    timestamp() {
      return fire.database.ServerValue.TIMESTAMP;
    }
  },
  computed: {
    users: function() {
      return this.chat_users();
    },
    roomsList: function() {
      return this.rooms.filter((val) => val.visible === true);
    }
  },
  mounted() {
    fire.database().ref('user_rooms/' + this.user.id).on("value", this.loadUserRooms);
  },
  unmounted() {
    fire.database().ref('user_rooms/' + this.user.id).off("value");
  },
}
</script>